import { ArrowUpRight } from "lucide-react";

const PRODUCTS = [
  {
    id: "top-performance",
    name: "Top Performance",
    label: "Sustentação · UV50+",
    price: "Em breve",
    desc: "Sustentação real, costuras planas e tecido premium. Para o corpo que você conquistou.",
    img: "https://customer-assets.emergentagent.com/job_gen-x-move/artifacts/nipzfl88_0070197C-7D6F-4C4C-8C92-FFA99C6EBECB.png",
    span: "lg:col-span-7 lg:row-span-2",
    aspect: "aspect-[4/5]",
  },
  {
    id: "legging-essential",
    name: "Legging Essential",
    label: "Compressão moderada",
    price: "Em breve",
    desc: "A legging que cobre, sustenta e fica bonita. Da pilates ao café.",
    img: "https://customer-assets.emergentagent.com/job_gen-x-move/artifacts/g4qtczkr_90A3748D-6061-42F3-B6BA-E476AB399A46.png",
    span: "lg:col-span-5",
    aspect: "aspect-[4/5]",
  },
  {
    id: "jaqueta-studio",
    name: "Jaqueta Studio",
    label: "Studio to Street",
    price: "Em breve",
    desc: "Tecido canelado premium, modelagem versátil. Veste qualquer momento do seu dia.",
    img: "https://customer-assets.emergentagent.com/job_gen-x-move/artifacts/v4ok6mig_Post_para_Instagram_-_Elevate_Your_Workout_Style.png",
    span: "lg:col-span-5",
    aspect: "aspect-[4/5]",
  },
];

const ProductCard = ({ p, idx }) => (
  <article
    data-testid={`product-card-${p.id}`}
    className={`reveal reveal-delay-${(idx % 3) + 1} ${p.span} group product-card`}
  >
    <div
      className={`product-frame ${p.aspect} border border-kora-gold/10 relative`}
    >
      <img
        src={p.img}
        alt={p.name}
        className="w-full h-full object-cover product-card-img"
        loading="lazy"
      />
      <div
        className="product-card-overlay pointer-events-none absolute inset-0 bg-kora-black/0 group-hover:bg-kora-black/20 transition-colors ease-out"
        style={{ transitionDuration: "350ms" }}
        aria-hidden="true"
      />
      <div className="absolute top-4 left-4 right-4 flex items-start justify-between z-[2]">
        <span className="font-mono-label text-kora-cream/85 bg-kora-black/45 backdrop-blur px-2.5 py-1">
          {p.label}
        </span>
        <span className="font-mono-label text-kora-gold-light bg-kora-black/45 backdrop-blur px-2.5 py-1">
          0{idx + 1}
        </span>
      </div>
    </div>
    <div className="mt-6 flex items-start justify-between gap-6">
      <div>
        <h3 className="font-display text-2xl md:text-3xl text-kora-cream">
          {p.name}
        </h3>
        <p className="mt-2 max-w-md text-sm text-kora-cream/70 leading-relaxed">
          {p.desc}
        </p>
      </div>
      <div className="text-right shrink-0">
        <p className="font-mono-label text-kora-gold-light">{p.price}</p>
      </div>
    </div>
  </article>
);

export const Collection = () => {
  return (
    <section
      id="colecao"
      data-testid="section-collection"
      className="relative bg-kora-black pt-28 pb-16 md:pt-40 md:pb-20"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24 reveal">
          <div>
            <p className="font-mono-label text-kora-gold-light mb-5">
              ✦ Coleção · 01
            </p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl leading-[1] tracking-tight text-kora-cream max-w-3xl">
              Eleve o seu{" "}
              <span className="italic text-gold-gradient">estilo ativo.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm md:text-base text-kora-cream/70 leading-relaxed">
            Tecidos premium de alta performance, pensados para conforto real,
            sustentação e elegância em cada movimento. Primeira coleção em
            breve.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.id} p={p} idx={i} />
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-kora-gold/15 pt-6 reveal">
          <p
            data-testid="collection-coming-soon"
            className="font-mono-label text-kora-cream/70"
          >
            ✦ Coleção completa em breve · Primeiras peças exclusivas para a
            Lista VIP
          </p>
        </div>
      </div>
    </section>
  );
};
